import {FunctionalHeader} from "../common/functional-header";
import {TechnicalHeaderInRequest} from "../common/technical-header-in-request";
import {UserInformation} from "../common/user-information";
import {DmsRequest} from "../common/dms-request";

export class CheckHealthRequest implements DmsRequest {
  simpleName: string = "check-health";
  functionalHeader: FunctionalHeader;
  technicalHeader: TechnicalHeaderInRequest;
  userInformation: UserInformation;
}
